<template>
    <div>
        <!-- account_block -->
        <div class="row account_block mt_sm">
            <div class="col-12">
                <div class="info_title account_block_title">
                    <b>Список адресов доставки</b>. Добавьте в список адреса,
                    отличающиеся от адресов плательщиков.
                </div>
                <div class="info_body">
                    <div class="form-inline ap_options">
                        <button
                            type="button"
                            class="btn btn_lg btn_common"
                            data-toggle="modal"
                            data-target="#modalAddress"
                        >
                            Показать адреса
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- //account_block -->

        <order-form-delivery-address-modal v-bind:checkable="false"></order-form-delivery-address-modal>
    </div>
</template>

<script>
export default {
    data: function () {
        return {};
    },
    methods: {},
    computed: {
    },
    mounted() {
        this.$store.dispatch("delivery/getDeliveries");
        this.$store.dispatch("delivery/getAddresses");
    },
};
</script>
